// eslint-disable-next-line
const {
  VUE_APP_HL: HL,
  VUE_APP_APP: SC,
  VUE_APP_JR: JR,
  VUE_APP_WO: WO,
  VUE_APP_HOME: HOME,
  VUE_APP_ZNT2,
} = process.env;
export const personMenuList = [
  {
    name: "我的商城",
    icon: "购物车",
    id: "store",
    child: [
      {
        name: "我的订单",
        id: "store01",
        cAhref: `${SC}v/order/list?appid=1&isShowTitle=1`,
        self: 0,
      },
      {
        name: "售后订单",
        id: "store11",
        cAhref: `${SC}v/aftersales/orderList?appid=1&isShowTitle=1`,
        self: 0,
      },
      {
        name: "采购订货",
        id: "store07",
        cAhref: `${SC}recommend/page.do?appid=1`,
        self: 0,
      },
      {
        name: "我的集采",
        id: "store02",
        cAhref: `${SC}groupPurchase/my/toMyNxinGroupPurchase.do?appid=1`,
        self: 0,
      },
      {
        name: "优惠券",
        id: "store03",
        cAhref: `${SC}cashCoupon/pc/toPage.do?appid=1`,
        self: 0,
      },
      {
        name: "收藏",
        id: "store04",
        cAhref: `${SC}member/favorite/listPage.do?appid=1`,
        self: 0,
      },
      {
        name: "账单",
        id: "store05",
        cAhref: `${SC}bill/page.do?appid=1`,
        self: 0,
      },
      {
        name: "地址信息",
        id: "store06",
        cAhref: `${SC}v/buyer/receive?isShowTitle=1`,
        self: 0,
      },
      {
        name: "采购积分",
        id: "store07",
        cAhref: `${SC}v/buyer/integral?isShowTitle=1`,
        self: 0,
      },
      {
        name: "推荐返利",
        id: "store08",
        cAhref: `${SC}v/buyer/distribution?isShowTitle=1`,
        self: 0,
      },
      {
        name: "常用车辆",
        id: "store09",
        cAhref: `${SC}v/buyer/comCart?isShowTitle=1`,
        self: 0,
      },
    ],
  },
  {
    name: "我的资产",
    icon: "assets",
    id: "assets",
    child: [
      {
        name: "我的余额",
        id: "assets02",
        cAhref: `${JR}v/accountAsset/balance`,
        self: 0,
      },
      {
        name: "我的农富宝",
        id: "assets03",
        cAhref: `${JR}v/accountAsset/nfb`,
        self: 0,
      },
      {
        name: "我的授信",
        id: "assets04",
        cAhref: `${JR}v/financingHomepage`,
        self: 0,
      },
      {
        name: "我的农信险",
        id: "assets08",
        cAhref: "https://www.nxinib.com/",
        self: 1,
      },
      {
        name: "我的农信度",
        id: "assets09",
        cAhref: `${JR}v/creditService/nxd`,
        self: 0,
      },
      {
        name: "我的银行卡",
        id: "assets09",
        cAhref: `${JR}v/accountManage/bankCard`,
        self: 0,
      },
    ],
  },
  {
    name: "个人信息",
    icon: "个人信息",
    id: "person",
    child: [
      {
        name: "我的资料",
        cAhref: `${WO}?hideFrame=true`,
        id: "person01",
        self: 0,
      },
      {
        name: "我的积分",
        cAhref: `${WO}jf?hideFrame=true`,
        id: "person02",
        self: 0,
      },
      {
        name: "我的企业",
        cAhref: `${WO}ent?hideFrame=true`,
        id: "person03",
        self: 0,
      },
      {
        name: "我的应用",
        cAhref: `${VUE_APP_ZNT2}intelligent?currTab=4&retUrl=${HOME}`,
        id: "person04",
        self: 1,
      },
      {
        name: "安全中心",
        cAhref: `${window.location.origin}/innerApps/safe`,
        id: "person05",
        self: 0,
      },
    ],
  },
];

export const personSeller = {
  name: "卖家中心",
  icon: "seller",
  id: "seller",
  child: [
    {
      name: "店铺主页",
      id: "seller01",
      cAhref: `${SC}mj/index.do?appid=1`,
      self: 0,
    },
    {
      name: "店铺管理",
      id: "seller02",
      cAhref: `${SC}mj/queryShopMJ.do?appid=1`,
      self: 0,
    },
    {
      name: "店铺装修-店铺导航栏",
      id: "seller03",
      cAhref: `${SC}satnav/toShopSatnav.do?appid=1`,
      self: 0,
    },
    {
      name: "店铺装修-货品分类管理",
      id: "seller04",
      cAhref: `${SC}classify/toShopClassify.do?appid=1`,
      self: 0,
    },
    {
      name: "店铺装修-首页装修",
      id: "seller05",
      cAhref: `${SC}index/toIndexCarouselFiguer.do?appid=1`,
      self: 0,
    },
    {
      name: "货品管理",
      id: "seller06",
      cAhref: `${SC}mj/toGoodsMJ.do?appid=1`,
      self: 0,
    },
    {
      name: "订单管理",
      id: "seller07",
      cAhref: `${SC}mj/order/manage/orderList.do?appid=1`,
      self: 0,
    },
    {
      name: "配送管理",
      id: "seller08",
      cAhref: `${SC}mj/toOtherAddr.do?appid=1`,
      self: 0,
    },
    {
      name: "运费管理",
      id: "seller09",
      cAhref: `${SC}mj/freight/toFreightListEtp.do?appid=1`,
      self: 0,
    },
    {
      name: "客户管理",
      id: "seller010",
      cAhref: `${SC}mj/customer/toCustomer.do?appid=1`,
      self: 0,
    },
    {
      name: "价格方案-从客户设置",
      id: "seller011",
      cAhref: `${SC}mj/price/toPriceMemberView.do?appid=1`,
      self: 0,
    },
    {
      name: "价格方案-从货品设置",
      id: "seller012",
      cAhref: `${SC}mj/price/toPriceGoodsView.do?appid=1`,
      self: 0,
    },
    {
      name: "促销管理",
      id: "seller013",
      cAhref: `${SC}mj/promotion/toSelectList.do?appid=1`,
      self: 0,
    },
    {
      name: "店铺优惠券",
      id: "seller014",
      cAhref: `${SC}mj/coupon/toShopCoupon.do?appid=1`,
      self: 0,
    },
    {
      name: "账单",
      id: "seller015",
      cAhref: `${SC}mj/bill/page.do?appid=1`,
      self: 0,
    },
    {
      name: "贷款结算",
      id: "seller016",
      cAhref: `${SC}mj/invoiceStatement/myInvoiceStatement.do?appid=1`,
      self: 0,
    },
    {
      name: "代销管理",
      id: "seller017",
      cAhref: `${SC}mj/toGoodsDealershipsList.do?appid=1`,
      self: 0,
    },
    {
      name: "我的返利",
      id: "seller018",
      cAhref: `${SC}mj/rebate/myRebate?appid=1`,
      self: 0,
    },
    {
      name: "权限分配",
      id: "seller019",
      cAhref: `${SC}mj/member/getAssign.do?appid=1`,
      self: 0,
    },
    {
      name: "运单列表",
      id: "seller020",
      cAhref: `${HL}/pc/order/toListHuo.do?appid=1`,
      self: 1,
    },
  ],
};
